import React from "react";

const HeroSection = () => {
  return (
    <div
      className=" small:h-screen  py-10 flex items-center justify-center text-center bg-cover  bg-no-repeat "
      style={{ backgroundImage: "url('/career-banner.png')" }}
    >
      <div className="flex flex-col justify-between px-6">
        <h1 className="text-[#FFC400] md:text-[62px] mb-2 small:text-4xl text-3xl font-bold uppercase">
          Join Our Team
        </h1>
        <p className="text-white  small:text-3xl text-xl font-semibold mt-4   small:animate-typing small:overflow-hidden small:whitespace-nowrap">
          {" "}
          Discover exciting career opportunities where innovation meets passion.{" "}
        </p>
        <p className="text-white md:text-[27px] text-xl mt-4">
          Be part of a dynamic{" "}
          <span class="text-yellow-400 font-semibold">
            {" "}
            team shaping the future of technology.
          </span>
        </p>
        <div className="flex justify-center py-2 small:relative top-[40px]">
          <img
            src={require("../../common/images/arrow.png")}
            alt=" arrow"
            className="w-[18px] h-[53px] cursor-pointer "
            onClick={() => document.getElementById("target-section")?.scrollIntoView({ behavior: "smooth" })}

          />
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
